<template>
  <div class="card">
    <Header :title="title">
      <div slot="right-sum" @click="onExchange">学习卡兑换</div>
    </Header>
    <Empty :empty_type="{name: '暂无兑换记录'}" v-if="list.length == 0" style="margin-top:20vw;"></Empty>
    <div class="content" v-else>
      <!-- <p class="title">兑换记录</p> -->
      <div class="timeline">
        <ul>
          <li v-for="(item, index) in list" :key="index">
            <!-- <div class="tail"></div> -->
            <!-- <div class="node"></div> -->
            <div class="line"></div>
            <!-- <p class="time">兑换时间：{{item.used_at | fomartTime('yyyy.MM.dd hh:mm')}}</p> -->
            <p class="shop-content">商品内容：{{item.title}}</p>
            <p class="card-number">学习卡号：{{item.card_number}}</p>
            <img class="cardExchange" src="@/assets/images/cardExchange.png">
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Empty from "@/components/Empty";
export default {
  name: "card",
  components: {
    Header,
    Empty
  },
  data() {
    return {
      title: {
        name: "我的学习卡"
      },
      list: [],
    };
  },
  methods: {
    onExchange() {
      this.$router.push({
        name: "Exchange"
      });
    }
  },
  created() {
    this.$http.post("/api/app/myStudy").then(res => {
      this.list = res;
    });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.card {
  @extend %default-bg;
  background-color: #f6f6f6;
  .content {
    margin: 31px 28px;
    // padding: 30px;
    border-radius: 15px;
    // background-color: #fff;
    .title {
      font-size: 30px;
      font-weight: 500;
      color: #262626;
    }
    .timeline {
      ul {
        // margin-top: 40px;
        li {
          margin-bottom: 20px;
          position: relative;
          padding: 0 30px;
          padding-top: 10px;
          height:230px;
          background:linear-gradient(0deg,rgba(59,144,255,1),rgba(109,172,255,1));
          box-shadow:1px 3px 4px 0px rgba(59,144,255,0.31);
          border-radius:20px;
          .line{
            width: 60px;
            height: 5px;
            background-color: #ffffff;
            margin: 26px auto;
            margin-bottom:60px;
          }
          .time,
          .card-number {
            font-size: 24px;
            color: #ffffff;
            font-weight:400;
            margin-top: 36px;
          }
          .cardExchange{
            width: 121px;
            height: 91px;
            position: absolute;
            right: 23px;
            bottom: 48px;
          }
          .shop-content {
            font-size: 30px;
            color: #ffffff;
            font-weight: 500;
          }
          .tail {
            position: absolute;
            top: 4px;
            left: 0;
            height: 100%;
            border-left: 4px solid #e9e9e9;
          }
          .node {
            position: absolute;
            top: 4px;
            left: -5px;
            width: 12px;
            height: 12px;
            border-radius: 50%;
            background-color: $theme_color;
          }
          p {
            margin-bottom: 20px;
            &:last-child {
              margin-bottom: 0;
            }
          }
          &:last-child .tail {
            display: none;
          }
          &:last-child {
            padding-bottom: 0;
          }
        }
      }
    }
  }
}
</style>
